import React, { FC, useEffect } from 'react'
import styles from 'styles/components/form.module.scss'
import { CardCvcElement, CardNumberElement, CardExpiryElement } from '@stripe/react-stripe-js'
import { FormLabel } from 'components/Label'
import { SubDescription } from 'components/Typography'
import { Spacer } from 'components/Utility'
import { useSelector, useDispatch } from 'react-redux'
import { State } from 'index'
import { getCard, getStripePaymentMethodId } from 'reducks/shop/selectors'
import { retrieveCard } from 'reducks/shop/operations'
import { zeroPadding } from 'lib/helper'

const elementStyle = {
  base: {
    fontSize: '16px',
    '::placeholder': {
      color: '#BABABA',
    },
    '::-webkit-input-placeholder': {
      color: '#BABABA',
    },
    '::-ms-input-placeholder': {
      color: '#BABABA',
    },
  },
}

const CheckoutForm: FC = () => {
  const dispatch = useDispatch()
  const card = useSelector((state: State) => getCard(state))
  const stripePaymentMethodId = useSelector((state: State) => getStripePaymentMethodId(state))

  useEffect(() => {
    if (!stripePaymentMethodId || stripePaymentMethodId === '') return
    dispatch(retrieveCard(stripePaymentMethodId))
  }, [stripePaymentMethodId])

  return (
    <form className={styles.table}>
      <FormLabel label={'クレジットカード番号'} required={true} />
      <Spacer size={8} />
      <CardNumberElement
        className={`${styles.text__input} ${styles.text__input_small}`}
        id={'card_number'}
        options={{
          style: elementStyle,
          placeholder: typeof card !== 'undefined' ? `●●●● ●●●● ●●●● ${card.last4}` : '',
        }}
      />
      <Spacer size={28} />
      <FormLabel label={'有効期限'} required={true} />
      <Spacer size={8} />
      <CardExpiryElement
        className={`${styles.text__input} ${styles.text__input_small}`}
        id={'expiry'}
        options={{
          style: elementStyle,
          placeholder:
            typeof card !== 'undefined' ? `${zeroPadding(card.exp_month)}/${card.exp_year.toString().slice(2, 4)}` : '',
        }}
      />
      <Spacer size={28} />
      <FormLabel label={'セキュリティコード'} required={true} />
      <Spacer size={8} />
      <CardCvcElement
        className={`${styles.text__input} ${styles.text__input_small}`}
        id={'cvc'}
        options={{
          style: elementStyle,
          placeholder: typeof card !== 'undefined' ? '●●●' : '',
        }}
      />
      <Spacer size={20} />
      <SubDescription
        description={
          'セキュリティコードとはクレジットカード番号とは別にカード裏面署名欄に記載された3桁の番号です。American Expressは表面に4桁で記載されていることもあります。'
        }
        size={'small'}
      />
    </form>
  )
}

export default CheckoutForm
